import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-component-name"]
const _hoisted_2 = ["xlink:href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_ctx.$root.spriteURL)
    ? (_openBlock(), _createElementBlock("svg", {
        key: 0,
        "data-component-name": _ctx.$options.name,
        class: _normalizeClass(["o-ico", $props.class]),
        "aria-hidden": "true",
        role: "img"
      }, [
        _createElementVNode("use", {
          "xlink:href": _ctx.$root.spriteURL+'#'+$props.icon
        }, null, 8 /* PROPS */, _hoisted_2)
      ], 10 /* CLASS, PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}